// Farm activity seen by everyone on the farm (owner 2026-10-03: "if I'm using Kombajn … people visiting me can't see
// it, I'd like them to see what I'm seeing"). Whoever works sends `farm_fx` (realtime.farmFx); everyone else on that
// farm plays it at the worker's spot. fxPlan turns one message into what to draw and play — pure (node --test).
import { ACTION_ICON } from './farmRules.mjs';
import { TOOLS, workFloat } from './vehicles.mjs';

export const PEER_GAIN = 0.5;          // someone else's work sounds at about half volume, so your own stays clear
const HAND_SFX = { plow: 'plow', plant: 'plant', harvest: 'harvest', remove_plot: 'zasyp' };
const BAR_ICON = { ...ACTION_ICON, water: '{plant}', feed: '{food}', pet: '{heart}' };     // + a visitor's help

export function fxPlan(m) {
  const at = { x: m.x ?? 0, y: m.y ?? 0 };
  const vehicle = TOOLS.includes(m.tool);
  const float = workFloat({ money: m.money ?? 0, fuel: m.fuel ?? 0, xp: m.xp ?? 0 });
  switch (m.kind) {
    case 'job_start':
      return vehicle ? { vehicle: { start: { tool: m.tool, size: m.size ?? 2, action: m.action, at } }, sound: `vehicle_${m.tool}` }
        : { bar: { start: BAR_ICON[m.action] ?? '{hoe}', face: at } };
    case 'job_progress':
      return vehicle ? { vehicle: { progress: m.p ?? 0 } } : { bar: { progress: m.p ?? 0 } };
    case 'job_end': {
      const out = vehicle ? { vehicle: { end: true } } : { bar: { end: true } };
      if (float) out.float = { at, label: float };
      if (!vehicle && HAND_SFX[m.action]) out.sound = HAND_SFX[m.action];
      return out;
    }
    case 'pet': return withFloat({ hearts: m.animal, sound: { animal: 'pet_animal', id: m.animal } }, at, float);
    case 'feed': return withFloat({ sound: { animal: 'feed_animal', id: m.animal } }, at, float);
    case 'collect': return withFloat({ sound: { animal: 'collect_animal', id: m.animal } }, at, float);
    case 'water': return withFloat({ drop: at, sound: 'water' }, at, float);
    default: return null;
  }
}

const withFloat = (plan, at, label) => (label ? { ...plan, float: { at, label } } : plan);

// progress updates: at most one per `ms`, the finishing 100 % always
export function progressThrottle(ms) {
  let last = -Infinity;
  return (p, now) => {
    if (p >= 1 || now - last >= ms) { last = now; return true; }
    return false;
  };
}
